/* eslint-disable */
import { useCallback } from 'react';
import useMountedState from './useMountedState';
var usePromise = function () {
    var isMounted = useMountedState();
    return useCallback(function (promise) {
        return new Promise(function (resolve, reject) {
            var onValue = function (value) {
                isMounted() && resolve(value);
            };
            var onError = function (error) {
                isMounted() && reject(error);
            };
            promise.then(onValue, onError);
        });
    }, []);
};
export default usePromise;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/usePromise.js
// module id = qrbN
// module chunks = 0